.dda-alert{
  padding: 24px;
  border-radius: 10px; 
  position: relative;
}
.dda-alert-inner{
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.dda-alert-icon-wrap{
  padding-top: 2px; 
}
.dda-alert .alert-content{
  width: 100%;
  display: grid;
  row-gap: 16px;
}
.dda-alert .alert-title{
  margin: 0; 
  font-size: var(--font-h6);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
}
.dda-alert .alert-description{
  margin: 0;
}
.alert-btn-wrap{
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 15px;
}
.dda-alert-close{
  position: absolute;
  inset-inline-end: 24px;
  inset-block-start: 24px;
  width: 20px;
  height: 2px;
  background: transparent;
  border: transparent;
  font-size: 18px;
}


/**/
.dda-alert-info{
  background: var(--dda-primary-variant-95);
  border: solid 1px var(--dda-color-primary-30);
}
.dda-alert-secondary.dda-alert-info .material-icons,
.dda-alert-secondary.dda-alert-info .alert-title{
  color: var(--dda-primary-40);
}
.light-mode.dda-alert-info{
  background: var(--dda-info-95);
  border: solid 1px var(--dda-info-40);
  color: var(--dda-info-40);
}

/**/
.dda-alert-warning{
  background: var(--dda-warning-variant-95);
  border: solid 1px var(--dda-color-warning-30);
}
.dda-alert-secondary.dda-alert-warning .material-icons,
.dda-alert-secondary.dda-alert-warning .alert-title{
  color: var(--dda-warning-40);
}
.light-mode.dda-alert-warning{
  background: var(--dda-warning-95);
  border: solid 1px var(--dda-warning-40);
  color: var(--dda-warning-40);
}
.dda-alert-warning .alert-primary-warning{
  background-color: var(--dda-warning-40);
  border: solid 1px var(--dda-warning-40);
}

/**/
.dda-alert-error{
  background: var(--dda-error-variant-95);
  border: solid 1px var(--dda-color-error-30);
}
.dda-alert-secondary.dda-alert-error .material-icons,
.dda-alert-secondary.dda-alert-error .alert-title{
  color: var(--dda-error-40);
}
.light-mode.dda-alert-error{
  background: var(--dda-error-95);
  border: solid 1px var(--dda-error-40);
  color: var(--dda-error-40);
}
.dda-alert-error .alert-primary-error{
  background-color: var(--dda-error-40);
  border: solid 1px var(--dda-error-40);
}

/**/
.dda-alert-success{
  background: var(--dda-success-variant-95);
  border: solid 1px var(--dda-color-success-30);
}
.dda-alert-secondary.dda-alert-success .material-icons,
.dda-alert-secondary.dda-alert-success .alert-title{
  color: var(--dda-success-40);
}
.light-mode.dda-alert-success{
  background: var(--dda-success-95);
  border: solid 1px var(--dda-success-40);
  color: var(--dda-success-40);
}
.dda-alert-success .alert-primary-success{
  background-color: var(--dda-success-40);
  border: solid 1px var(--dda-success-40);
}

/**/


.dda-alert-secondary{
  background-color: var(--dda-surface-100);
  border: solid 1px var(--dda-surface-90);
  color: var(--dda-on-surface-0);
  box-shadow: 0px 1px 2px 0px #1018280A;
}
.dda-alert .alert-secondary-button{
  border: solid 1px var(--dda-surface-100);
}
.dda-alert-secondary .alert-secondary-button{
  border: solid 1px var(--dda-surface-90);
}
/**/
